import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { ActivityAsyncAdapter } from './activity.adapter';
import { Metamodel } from 'app/model/base/model';
import _ from 'lodash';
import { ReferenceAdapter } from '../reference.adapter';
import { toParameterClass, toParameterObject } from 'app/model/adapters/linkedservices/parameter-config.util';
import { SynapseStoredProcedureActivity, SqlPool, A365BackendModel } from 'shell-models-lib';
import { ValueAdapter } from '../value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SynapseStoredProcedureActivity),
    asynchronous: true,
    adapts: {
        name: '*',
        description: '*',
        type: '*',
        dependsOn: '*',
        policy: '*',
        sqlPool: '*',
        sqlCompute: '*',
        userProperties: '*',
        typeProperties: {
            storedProcedureName: '*',
            storedProcedureParameters: '*'
        }
    }
})
export class SynapseStoredProcedureActivityAdapter extends ActivityAsyncAdapter<SynapseStoredProcedureActivity, A365BackendModel.SynapseStoredProcedureActivity> {
    protected async _toResource(activity: SynapseStoredProcedureActivity): Promise<A365BackendModel.SynapseStoredProcedureActivity> {
        const modelStoreProcedureActivity = super._getCommonActivityProperties(
            activity, Metamodel.modelFor(SynapseStoredProcedureActivity).name) as A365BackendModel.SynapseStoredProcedureActivity;

        modelStoreProcedureActivity.sqlPool =
            this._getSqlPoolReference(activity.sqlPool);

        modelStoreProcedureActivity.typeProperties = {
            storedProcedureName: ValueAdapter.toResource(activity, SynapseStoredProcedureActivity.NAME),
            storedProcedureParameters: toParameterObject(activity.sprocParameters, true)
        };

        if (activity.raw) {
            const parsed = JSON.parse(activity.raw);
            _.merge(modelStoreProcedureActivity, parsed);
        }

        return modelStoreProcedureActivity;
    }

    protected async _toModel(modelActivity: A365BackendModel.SynapseStoredProcedureActivity): Promise<SynapseStoredProcedureActivity> {
        const activity = SynapseStoredProcedureActivity.MODEL.create<SynapseStoredProcedureActivity>(
            modelActivity.name,
            modelActivity.description);

        this._updatedCommonProperties(modelActivity, activity);

        activity.sqlPool = ReferenceAdapter.toProxyModel<SqlPool>(
            Metamodel.modelFor(SqlPool),
            modelActivity.sqlPool, this.context);

        if (modelActivity.typeProperties) {
            ValueAdapter.toModel(activity, SynapseStoredProcedureActivity.NAME, modelActivity.typeProperties.storedProcedureName);
            activity.sprocParameters = toParameterClass(modelActivity.typeProperties.storedProcedureParameters, activity, true);
        }

        activity.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelActivity, SynapseStoredProcedureActivity.MODEL));
        return activity;
    }

    private _getSqlPoolReference(named: SqlPool): Model.ArtifactReference {
        if (!named) {
            return undefined;
        }

        return ReferenceAdapter.toResource(named, this.context) as Model.ArtifactReference;
    }
}
